import { useEffect, useRef, useState } from "react";
import Prism from "prismjs";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-okaidia.css";
import { IoClipboardOutline } from "react-icons/io5";
import { FaCheck, FaCode } from "react-icons/fa6";
import "./CourseContent.css";
import { RiShareForward2Fill } from "react-icons/ri";
import { useNavigate, useParams } from "react-router-dom";
import SkeletonLoader from "../../loaders/SkeletonLoader";
import NotFound from "../../loaders/NotFound";

function CourseContent({ currentQuestion }) {
  const codeRef = useRef(null);
  const [codeCopied, setCodeCopied] = useState(false);
  const [loading , setLoading] = useState(true);
  const navigate = useNavigate()

  useEffect(() => {
    Prism.highlightAll();
  }, [currentQuestion]);

  const handleCopy = (code) => {
    setCodeCopied(true);
    window.navigator.clipboard
      .writeText(code)
      .then(() => {
        setTimeout(() => {
          setCodeCopied(false);
        }, 1500);
      })
      .catch((error) => {
        console.error("Failed to copy code to clipboard:", error);
        setCodeCopied(false);
      });
  };

  const { courseParam, difficulty } = useParams();
  const handleShareItem = (item) => {
    if (navigator.share) {
      navigator
        .share({
          title: `student.webgeniuscraft.com`,
          text: "Check out this awesome website!",
          // url: `https://student.webgeniuscraft.com/${courseParam}/${difficulty}/${item}`
          url: `http://localhost:3000/categories/${courseParam}/${difficulty}/${item}`
        })
        .then(() => console.log("Successfully shared"))
        .catch((error) => console.error("Error sharing:", error));
    } else {
      alert("Sharing is not supported in this browser");
    }
  };

  const handleOpenWithEditor = (code) => {
    navigate('/code', { state: code });
  };
  

  useEffect(() => {
   setTimeout(() => {
      setLoading(false)
   }, 1000);
  }, [])

  return (
    <div className="customScroll relative p-4 pt-10 h-full overflow-y-scroll bg-gray-900 rounded shadow-lg">
      {loading ? <>
      <SkeletonLoader />
      </> :
      <>
      {!currentQuestion ? 
      <NotFound /> : (
        <div>
          <RiShareForward2Fill
            className="shareIcon absolute right-1 top-3 text-[1.5rem] p-1 rounded box-content border-white hover:bg-gray-800 cursor-pointer border-2"
            onClick={() => handleShareItem(currentQuestion?._id)}
          />
          <ul className="text-white mb-4 h-full">
            <li className="mb-2">
              <span className="font-bold text-yellow-500">Question:</span>{" "}
              {currentQuestion?.questionText}
            </li>
            <li className="mb-2">
              <span className="font-bold text-yellow-500">Answer:</span>{" "}
              {currentQuestion?.answerText}
            </li>
            {/* <li className="mb-2">
              <span className="font-bold text-yellow-500">Course Name:</span>{" "}
              {currentQuestion.courseName}
            </li> */}
          </ul>

          <section className="flex flex-col rounded-md justify-between align-center  bg-gray-800">
            <div className=" codeExampleItems flex w-full justify-between items-center px-5 py-1">
              <span className="text-gray-500">
                {currentQuestion?.courseName}
              </span>

                
            <span className="flex items-center flex-row justify-around h-full">
            {currentQuestion.courseName !== "css" && "open with editor"}
            {currentQuestion?.courseName !== "css" &&  
            <FaCode className="text-gray-500 hover:text-gray-100 mr-5 ml-2 cursor-pointer" onClick={() => handleOpenWithEditor(currentQuestion.codeExample)} />
          }
              {codeCopied ? (
                <FaCheck className="text-gray-500 hover:text-gray-100" />
                ) : (
                  <IoClipboardOutline
                  className="cursor-pointer text-gray-500 hover:text-gray-100"
                  onClick={() => handleCopy(currentQuestion?.codeExample)}
                  />
                  )}
                  </span>
            </div>
            
            <pre
              className="p-4 h-auto  overflow-auto cursor-text"
              style={{ backgroundColor: "#000000", margin: "0" }}
              onClick={() => currentQuestion.courseName !== "css" && window.confirm("Are you sure you want to open code editor!") && currentQuestion.courseName !== "css" && handleOpenWithEditor(currentQuestion?.codeExample)} 
            >
              {/* 2D2D2D */}
              <code
                ref={codeRef}
                className="language-javascript"
                style={{ textShadow: "none", color: "#D8D8D8" }}
              >
                {currentQuestion?.codeExample}
              </code>
            </pre>
          </section>
        </div>
      )
      }
      </>}
    </div>
  );
}

export default CourseContent;
